export default class Isi {
    constructor() {
        this.windowHeight = window.innerHeight;
        this.homeBase = document.getElementById("isi");
        this.stickyIsi = document.querySelector(".isi-container");
        this.isiButton = document.querySelector(".isi-button");

        this.init();
    }

    init() {
        if (this.homeBase) {
            if (document.body.clientHeight < 2200) {
                this.stickyIsi.classList.remove("isi-container--fixed");
                this.isiButton.remove();
            } else {
                window.addEventListener("scroll", () => {
                    if (window.scrollY + this.windowHeight - 200 > this.homeBase.offsetTop) {
                        this.stickyIsi.classList.remove("isi-container--fixed");
                    } else {
                        this.stickyIsi.classList.add("isi-container--fixed");
                    }
                });
            }
        }
    }
}
